<nz-spin [nzSpinning]="isLoading">
    <div style="overflow-x: auto; max-width: 70vw">
        <!-- 添加输入框和搜索按钮 -->
        <div style="margin-bottom: 16px;">
            <input type="text" [(ngModel)]="searchKeyword" style="margin-right: 8px; padding: 4px; width: 200px;"
                (keyup.enter)="searchUsers()" />
            <button nz-button nzType="primary" (click)="searchUsers()">{{ "Search" | translate }}</button>
        </div>
        <span>{{maxItemDisplay}}</span>
        <nz-table nzBordered [nzData]="userData" [nzFrontPagination]="false">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ "UserId" | translate }}</th>
                    <th>{{ "ChineseName" | translate }}</th>
                    <th>{{ "EnglishName" | translate }}</th>
                    <th>{{ "deptCode" | translate }}</th>
                    <th>{{ "Email" | translate }}</th>
                    <th>{{ "IdentityType" | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of userData">
                    <td>
                        <nz-radio-group [(ngModel)]="selectedUser"
                            [nzDisabled]="user.userType!=='User' && user.isAccountLocked">
                            <label nz-radio [nzValue]="user"></label>
                        </nz-radio-group>
                    </td>
                    <td>{{ user.userId }}</td>
                    <td>{{ user.chineseName }}</td>
                    <td>{{ user.englishName }}</td>
                    <td>{{ user.deptId }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ layoutServ.getUserTypeDisplay(user.userType) }}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>